export default "__VITE_ASSET__BASe5OsL__"